import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

const pulse = keyframes`
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.6;
    }
    100% {
      opacity: 0;
    }
`;

export const TypingIndicator = () => {
  return (
    <Box
      sx={{
        display: 'flex',
      }}
    >
      {[1, 2, 3].map((index) => (
        <Box
          key={index}
          sx={{
            bgcolor: 'primary.main',
            width: 8,
            height: 8,
            borderRadius: '50%',
            marginX: '2px',
            animation: `${pulse} 1.2s ${index * 0.2}s infinite`,
          }}
        />
      ))}
    </Box>
  );
};
